module.exports = __webpack_public_path__ + "img/icon-camera.b8c44047.svg";